import React, {useContext, useMemo, useState} from "react";
import {maxiGet} from "../core/maxios";
import Status from "../core/status";
import {BlankLink, Container, Loader} from "../core/components/components";
import {UserContext} from "./UserContext";
import DOMPurify from "dompurify";
import {Link} from "react-router-dom";

function Logo({data}) {
    if (typeof data === "string") {
        return <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(data || "")}}/>
    }
    if (data.type === "img") {
        return <img {...data.props}/>
    }
    return React.createElement(data.type, data.props, data.props.children.map(a => a.type ? React.createElement(a.type, a.props, a.props.children) : a))
}

export default function VereinID({}) {
    const [users, setUsers] = useState([]);
    const [{error, loading}, setStatusVar] = useState({});
    const context = useContext(UserContext);

    useMemo(() => setStatusVar({loading: true}) || maxiGet("/vereinid/list", {setStatusVar}).then(({users}) => setUsers(users)), [])
    return <Container name={"Meine Benutzerkonten bei VEREINfacht-Softwarelösungen"}>
        <Status type={"error"} text={error}/>
        <Loader loading={loading}/>
        {
            <div style={{marginBottom: "30px"}}><Logo data={context?.club?.logo}/><br/><a href={"/"} rel={"noopener noreferrer"}>{context?.club?.name}</a> (<b>momentan hier</b>)</div>
        }

        {
            users.map(({platform, name, login_url, logo}) => <div style={{marginBottom: "30px"}} className={"vereinidContainer"}><Logo data={logo}/><br/><a href={login_url} target={window.safeAreaInsets ? undefined : "_blank"} rel={window.safeAreaInsets? undefined : "noopener noreferrer"}>{platform} ({name})</a></div>)
        }
        {
            users.length === 0 && <p>Leider keine anderen Konten gefunden.</p>
        }

        <h3>Was wird hier angezeigt?</h3>
        Hier werden alle Konten bei VEREINfacht-Softwarelösungen angezeigt, die auf die gleiche E-Mail-Adresse ({context?.user?.email}) wie du hier angemeldet bist, lauten.<br/>
        Überprüft werden alle VEREINfacht benutzenden Vereine, die ÖFT Melde- und Lizenzplattform <BlankLink>mein.oeft.at</BlankLink> und die Melde und Berechnungsplattform von Turnfest / dem ÖTB OÖ <BlankLink>meldung.turnfest.at</BlankLink>.
    </Container>
}
